<template>
  <div v-if="data" class="page-container pt-3 pb-4">
    <div class="row p-4 text-white align-items-center no-gutters px-2 shiur-container mb-4">
      <div class="col-12 col-md">
        <div class="row no-clear">
          <v-select
            class="select-filter col-12 col-sm-8 text-white"
            v-model="currentMasechta"
            :placeholder="$_t('KW:masechta')"
            :options="data.masechtot"
          ></v-select>
          <v-select class="select-filter text-white col-12 col-sm-4" v-model="currentDaf" :placeholder="$_t('KW:daf')" :options="data.dafs"></v-select>
        </div>
      </div>
      <div class="col-12 col-md px-2 row align-items-center no-gutters mt-md-0 mt-2">
        <router-link
          :title="$_t('KW:previous')"
          :to="{
            name: 'shiur-single',
            params: {
              masechta: data.current.url_key,
              daf: data.current.daf - 1,
            },
          }"
          v-if="data.current.daf - 1 > 1"
          class="col-2 fa fa-chevron-left text-center"
        ></router-link>
        <span class="col-8 text-center">{{ data.current.date }}</span>
        <router-link
          :title="$_t('KW:next')"
          :to="{
            name: 'shiur-single',
            params: {
              masechta: data.current.url_key,
              daf: data.current.daf + 1,
            },
          }"
          v-if="data.dafs[data.current.daf - 1]"
          class="col-2 fa fa-chevron-right text-center"
        ></router-link>
      </div>
      <div class="d-md-flex d-none col-auto daf-hebrew" v-if="data && !isRTL">
        {{ data.current.name_hebrew }}
        {{ parseInt(data.current.daf) | gematriya }}
      </div>
    </div>
    <div style="font-size: 1.2rem" class="text-center" v-for="shiurim in data.shiurim">
      <div class="my-3" v-if="shiurim.sponsor.length > 0">
        <div>
          <span class="">{{ $_t('KW:sponsoredByMessageShas', { names: shiurim.sponsor.map(s => s.name).join(',') }) }}</span>
        </div>
        <div v-if="shiurim.dedicated_to">
          <span>{{ shiurim.dedicated_to }}</span>
        </div>
      </div>
    </div>
    <ul class="list-unstyled border p-3 text-center text-sm-left">
      <li v-for="(shiur, index) in data.shiurim" class="row no-gutters align-items-center mb-4" :class="index % 2 == 0 ? 'bg-lightgray' : ''">
        <router-link
          :to="{
            name: 'magideiShiur',
            params: { slug: shiur.lecturer.url_key },
          }"
          class="col-auto pr-1 text-center mx-auto mx-sm-0"
        >
          <b-img-lazy
            blank-src="/static/blank_profile.jpg"
            :src="imgsrc(shiur.lecturer)"
            fluid
            :alt="shiur.lecturer.name"
            class="shiur-container-profile-img"
          />
        </router-link>
        <div class="col-sm-6 col-12 col-md pl-1 text-center">
          <div v-if="shiur.message">
            <strong>{{ shiur.message }}</strong>
            <br />
          </div>
          <router-link
            :to="{
              name: 'magideiShiur',
              params: { slug: shiur.lecturer.url_key },
            }"
            >{{ shiur.lecturer.name }}</router-link
          >
        </div>
        <div class="col-12 col-sm-2 px-2 text-center" v-if="shiur.length != '00:00'">
          {{ shiur.length }}
        </div>
        <div class="col-12 col-md px-md-2">
          <div class="mt-3 mt-md-0 float-md-right">
            <action-buttons :magid-shiur="shiur.lecturer" :shiurim="shiur" type="shas"></action-buttons>
          </div>
        </div>
      </li>
    </ul>
    <div class="row align-items-center">
      <div class="col-auto mx-auto mb-4">
        <div class="text-center text-blue text-uppercase">
          <strong>{{ $_t('KW:showDaf') }}</strong>
        </div>
        <span class="btn-group">
          <a
            class="btn bg-dark-blue text-white"
            rel="noreferrer"
            :href="'http://beta.hebrewbooks.org/shas.aspx?mesechta=' + data.current.hebrewbooks_id + '&daf=' + data.current.daf + '&format=pdf'"
            target="_blank"
            >עמוד א</a
          >
          <a
            class="btn bg-yellow text-blue"
            rel="noreferrer"
            :href="'http://beta.hebrewbooks.org/shas.aspx?mesechta=' + data.current.hebrewbooks_id + '&daf=' + data.current.daf + 'b&format=pdf'"
            target="_blank"
            >עמוד ב</a
          >
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import VueSelect from 'vue-select';
import actionButtonsComponent from '../partials/ActionButtons.vue';
import DafComponent from '../masechta/Daf';
export default {
  components: {
    Daf: DafComponent,
    vSelect: VueSelect,
    actionButtons: actionButtonsComponent,
  },
  metaInfo: function() {
    return {
      title: this.metaTitle,
      meta: [{ name: 'description', content: this.metaDescription }],
    };
  },
  computed: {
    metaTitle: function() {
      return this.currentMasechta && this.currentDaf && `${this.currentMasechta.label} ${this.currentDaf.label}`;
    },
    metaDescription: function() {
      return this.currentMasechta && this.currentDaf ? this.$_t('KW:site.metaWithName', { name: `${this.currentMasechta.label} ${this.currentDaf.label}` }) : this.$_t('KW:site.metaWithoutName');
    },
  },
  data: function () {
    return {
      data: {
        shiurim: [],
        masechtot: null,
        dafs: null,
        current: null,
      },
      currentDaf: null,
      currentMasechta: null,
      mareiMekomos: {
        note: null,
        shiurim: {
          daf: null,
          message: null,
          lecturer: {
            name: null,
          },
        },
      },
    };
  },
  created: function () {
    this.getData();
  },
  watch: {
    $route: 'getData',
    currentDaf: function (val, old) {
      if (old) {
        this.$router.push({
          name: 'shiur-single',
          params: {
            masechta: this.currentMasechta.value,
            daf: val.value,
          },
        });
      }
    },
    currentMasechta: function (val, old) {
      if (old && old.value != val.value) {
        this.$router.push({
          name: 'masechta',
          params: { slug: val.value },
        });
      }
    },
  },
  methods: {
    setCurrent: function (data) {
      this.currentMasechta = {
        value: data.current.url_key,
        label: data.current.name,
      };
      this.currentDaf = {
        value: data.current.daf,
        label: data.current.daf,
      };
    },
    getData: function () {
      var url = '/api/shiur/today';
      if (this.$route.params.masechta && this.$route.params.daf) {
        url = '/api/shiur/masechta-' + this.$route.params.masechta + '/daf-' + this.$route.params.daf;
      }
      var self = this;
      this.data = null;
      this.loading = true;
      this.$http.get(url).then(function (response) {
        self.data = response.data;
        self.setCurrent(response.data);
        self.loading = false;
      });
    },
    imgsrc: function (magidShiur) {
      if (magidShiur.image) {
        return magidShiur.image.url;
      } else {
        return '/static/blank_profile.jpg';
      }
    },
  },
};
</script>
<style lang="scss">
.shiur-container {
  background: $dark-blue;
  .select-filter {
    font-size: 1rem;

    @media (max-width: 768px) {
      margin-bottom: 15px;
      .dropdown-toggle {
        height: 45px;
      }
      ul.dropdown-menu li {
        padding: 5px 0px;
      }
      .dropdown-toggle {
        height: 45px;
      }
    }

    color: white;
    .vs__selected-options input::placeholder {
      color: white;
    }
    .vs__actions {
      .clear span,
      i::before {
        border-color: white;
        color: $white;
      }
    }
    .dropdown-toggle {
      border-color: white;
      .selected-tag {
        color: white;
      }
    }
  }
  .fa-chevron-left,
  .fa-chevron-right {
    color: white;
    font-size: 1rem;
  }
}
.dedication-card {
  background: $white;
  color: $dark-blue;
  font-size: 1.05rem;
}
.shiur-container-profile-img {
  height: 180px;
}
</style>
